import { render, staticRenderFns } from "./XmGoodsInfo.vue?vue&type=template&id=0153522c&scoped=true"
import script from "./XmGoodsInfo.vue?vue&type=script&lang=js"
export * from "./XmGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./XmGoodsInfo.vue?vue&type=style&index=0&id=0153522c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153522c",
  null
  
)

export default component.exports